/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { DeviceFeatures } from "../../device";
import type { IServiceControlledFeatureProvider } from "../../interfaces";
import type { TServiceFeatureMapping } from "../types";

/**
 * NPVR source for SERVICE_CONTROLLED features. Reads the last known
 * `npvrAllowRecording` enabled flag DeviceFeatures holds; `null` until an NPVR
 * response has been received this session. The network fetch that populates it
 * happens in the normal interactor/thunk flow, never here.
 */
export class NpvrFeatureSource implements IServiceControlledFeatureProvider {
  public getFeatureState(_mapping: TServiceFeatureMapping): boolean | null {
    return DeviceFeatures.getNpvrRecordingState();
  }
}
